/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxfHoursV1MoneyMarketScheduleEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXF_HOURS_V1_MONEY_MARKET_SCHEDULE_EVENT_ENTITY_NAME = 'ixf.hours.v1.MoneyMarketScheduleEvent';
export const ixfHoursV1MoneyMarketScheduleEventEntity = new schema.Entity<IxfHoursV1MoneyMarketScheduleEvent>(IXF_HOURS_V1_MONEY_MARKET_SCHEDULE_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxfHoursV1MoneyMarketScheduleEvent) => `${entity.metadata?.eventId}` });

